module.exports = __webpack_public_path__ + "img/pic-29.fa30c642.png";